import { zodResolver } from '@hookform/resolvers/zod';
import { createContext, useContext } from 'react';

export const CustomFormContext = createContext<{
    zod?: Parameters<typeof zodResolver>[0];
    disabled?: boolean;
}>({ zod: undefined, disabled: undefined });
export const useCustomFormContext = () => useContext(CustomFormContext);
